import React, { Component, PropTypes } from 'react';
import getTopOffset from '../../../utils/getOffsetTop';

//import css from './content.scss';

export default class EditorialContentQA extends Component {
	static PropTypes = {
		content: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired
	};

	static defaultProps = {
		content: {
			question: '',
			answer: '',
		},
	};

	constructor(props) {
		super();

		this.mounted = true;

		this.scroll = this.scroll.bind(this);

		this.state = {
			placeholderHeight: 0,
			placeholderWidth: 0,
			posToStick: -1,
			posToStickEndStick: -1,
			isSticky: false,
		};
	}

	componentDidMount() {
		this.props.browser.scroll.register(this.scroll);
		this.updateDimensions();
		//this.stickify(this.refs.stickyPrimary, this.refs.stickyPlaceholder, this.refs.stickyWrapper);
	}

	componentDidUpdate() {}

	componentWillUnmount() {
		this.props.browser.scroll.deregister(this.scroll);
		this.mounted = false;
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.browser.window.width !== nextProps.browser.window.width) {
			this.updateDimensions();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.content.question !== prevProps.content.question) {
			this.updateDimensions();
		}
	}

	render() {
		let { question, answer } = this.props.content;
		let phStyle = {};
		let qStyle = {};

		phStyle.height = this.state.placeholderHeight + 'px';
		phStyle.height = this.state.placeholderHeight + 'px';

		if (this.state.isSticky) {
			qStyle.top = (this.props.browser.window.width > 719 ? 61 : 50) + 'px';
			qStyle.position = 'fixed';
		} else {
			qStyle.position = 'absolute';
			qStyle.top = '0px';
		}

		if (!this.state.placeholderHeight) {
			setTimeout(() => {
				this.updateDimensions();
			}, 500);
		}

		return (
			<section className='editorial-content__section__qa-wrapper' ref='stickyWrapper'>
				<div className='placeholder' ref='stickyPlaceholder' style={phStyle}></div>
				<div className='cf editorial-content__section editorial-content__section__question span8 span8-tablet span14-mobile' ref='stickyPrimary' style={qStyle}>
					<div className='span5 span7-tablet span12-mobile'>
						<h2 dangerouslySetInnerHTML={{ __html: question }}></h2>
					</div>
				</div>
				<div className='cf editorial-content__section editorial-content__section__answer'>
					<div className='span5 span7-tablet span12-mobile' dangerouslySetInnerHTML={{ __html: answer }}></div>
				</div>
			</section>
		);
	}

	updateDimensions() {
		let stWrapper = this.refs.stickyWrapper;
		let stPrimary = this.refs.stickyPrimary;
		let stPlaceholder = this.refs.stickyPlaceholder;
		let newState = { ...this.state };

		if (!this.mounted) {
			return;
		}

		newState.posToStick = getTopOffset(stPlaceholder);
		newState.posToStickEndStick = newState.posToStick + stWrapper.clientHeight;
		newState.placeholderHeight = stPrimary.clientHeight;
		newState.placeholderWidth = stPrimary.clientWidth;

		//console.log('update qa dims');

		this.mounted && this.setState(newState);
	}

	scroll(e) {
		let isMobile = (this.props.browser.window.width <= 719);
		let scrollY = e.scrollY + (!isMobile ? 61 : 50); // account for top-nav

		// if (scrollY > this.state.posToStick && scrollY < this.state.posToStickEndStick) {
		// 	console.log(this.refs.stickyWrapper.getAttribute('data-reactid').substr(-1, 2));
		// }

		let isSticky = (scrollY > this.state.posToStick && scrollY < this.state.posToStickEndStick);
		if (isSticky !== this.state.isSticky) {
			//console.log(isSticky ? 'stick' : 'unstick');
			this.mounted && this.setState({
				...this.state,
				isSticky: (!isMobile && scrollY > this.state.posToStick && scrollY < this.state.posToStickEndStick),
			});
		}
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/editorial/content/qa.js
 **/